import axios from 'axios'

// 创建 axios 实例
const service = axios.create({
  baseURL: "", // url = base url + request url
  withCredentials: true,
  timeout: 10000, // request timeout
})

//  请求拦截器
service.interceptors.request.use(
  (config) => {
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    config.headers['Accept'] = 'application/json'
    config.headers['Request-From'] = 'mobile'
    var path = window.location.pathname;
    var index = path.lastIndexOf("/");
    var id = path.substring(index + 1, path.length);
    let token = localStorage.getItem('loginToken' + id) || null
    if (token) {
      if (config.url.includes('getLoginPageInfo')) {
        // 登录接口
      } else if (config.url.includes('getIdentifyCode')) {
        // 图片验证码接口
      } else if (config.url.includes('getWeChatAutograph')) {
        // 微信分享
      } else if (config.url.includes('login')) {
        // 登录
      } else if (config.url.includes('loginByCode')) {
        // 手机登录
      } else {
        // 如果token不为null，否则传token给后台
        config.headers['Authorization'] = token
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

import router from '../router';
// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data
    //届时根据后端返回success或者code值判断
    if (res.code === 401) {
      // 获取当前URL的路径部分
      var path = window.location.pathname;
      var index = path.lastIndexOf("/");
      var id = path.substring(index + 1, path.length);
      localStorage.removeItem('loginToken' + id);
      localStorage.removeItem('loginInfo');
      localStorage.removeItem('activeName');
      localStorage.removeItem('examResult');
      router.push('/login/' + id);
      return res
    } else {
      return res
    }
  },
  (error) => {
    //响应错误
    return Promise.reject(error)
  }
)

export default service